import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-top: 8px solid ${colors.Blue300};
  border-bottom: 1px solid ${colors.Grey100};
  border-left: 1px solid ${colors.Grey100};
  border-right: 1px solid ${colors.Grey100};
  border-radius: 8px 8px 0px 0px;
`;

export const StyledTable = styled.table<{ disabled}>`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 600px;

  th, td {
    padding: 16px 12px;
    border-bottom: 1px solid ${colors.Grey100};

    /* Quebra de linha automática */
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;

    /* Alinhamento consistente */
    text-align: left;
    vertical-align: top;
  }

  /* Header */
  th {
    font-weight: 600;
  }

  td.centered, th.centered {
    text-align: center;
  }

  /* Hover nas linhas */
  ${({ disabled }) => (disabled ? '' : `
    tr:hover td {
      background-color: ${colors.Grey050};
    }
  `)}

  /* Remove bordas verticais entre colunas */
  th + th,
  td + td {
    border-left: none;
  }


`;
